import styles from "./DrawdownMeter.module.css";

// Thin bar + "1.2%/5%" readout. Tone follows how much of the limit is used:
// under half is brand green, from half is gold, at the limit is red.
export default function DrawdownMeter({ value, limit, label }) {
  const used = value === null || value === undefined ? null : Math.max(0, Number(value));
  const ratio = used === null || !limit ? 0 : Math.min(1, used / limit);
  const tone = ratio >= 1 ? styles.danger : ratio >= 0.5 ? styles.warning : styles.brand;
  const display = used === null ? "—" : `${Number(used.toFixed(1))}%`;

  return (
    <div className={`${styles.meter} ${tone}`}>
      <div
        className={styles.track}
        role="meter"
        aria-label={label}
        aria-valuemin={0}
        aria-valuemax={limit}
        aria-valuenow={used ?? 0}
      >
        <div className={styles.fill} style={{ width: `${ratio * 100}%` }} />
      </div>
      <p className={styles.readout}>
        {display}
        <span className={styles.limit}>/{limit}%</span>
      </p>
    </div>
  );
}
